import React, { FC } from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';

import Flex, {
  desktopOnlyDisplay,
  MaxWidthBackgroundWrapper,
  MaxWidthContentWrapper,
  maxWidthPadding,
} from './TahoraUI/Flex';
import { Link, P } from './TahoraUI/Typography';
import Button from './TahoraUI/Button';
import Input from './TahoraUI/Input';
import DesktopShape from '../images/shapes/footer-shape-desktop.svg';

interface SocialIconsProps {
  icons?: readonly (
    | GatsbyTypes.PrismicFooterDataFooter_social_icons
    | undefined
  )[];
}

const Img = styled.img`
  max-width: 100%;
`;

const SocialIcons: FC<SocialIconsProps> = ({ icons }) => {
  return (
    <Flex mb={4}>
      {icons?.map(socialIcon => {
        return (
          <Link
            key={socialIcon?.footer_social_icon_link?.url}
            href={socialIcon?.footer_social_icon_link?.url}
            target="__blank"
            fontSize={0}
            lineHeight="0px"
            mr={3}
          >
            <Flex
              key={socialIcon?.footer_social_icon_link?.url}
              borderRadius="50%"
              width={['30px', '40px', '40px']}
              height={['30px', '40px', '40px']}
              border="silverThin"
              alignItems="center"
              justifyContent="center"
              p={2}
            >
              <Img
                src={socialIcon?.footer_social_icon_image?.url}
                alt={socialIcon?.footer_social_icon_image?.alt}
              />
            </Flex>
          </Link>
        );
      })}
    </Flex>
  );
};

interface FooterLinksProps {
  heading?: string;
  links?: readonly (
    | GatsbyTypes.PrismicFooterDataFooter_column_1_content
    | undefined
  )[];
}
const FooterLinks: FC<FooterLinksProps> = ({ heading, links }) => {
  return (
    <Flex flexDirection="column" width={['50%', '50%', '25%']} mb={[8, 8, 0]}>
      <P color="white" mb={2} fontSize={0}>
        {heading}
      </P>
      {links?.map(link => {
        return (
          <Link
            key={link?.footer_column_navigation_label?.[0]?.text}
            mb={2}
            fontSize={0}
            color="silver"
            href={link?.footer_column_navigation_link?.url}
          >
            {link?.footer_column_navigation_label?.[0]?.text}
          </Link>
        );
      })}
    </Flex>
  );
};

const Footer = () => {
  const data = useStaticQuery<GatsbyTypes.FooterQuery>(graphql`
    query Footer {
      footer: prismicFooter {
        content: data {
          footer_column_1_content {
            footer_column_navigation_label {
              text
              type
            }
            footer_column_navigation_link {
              url
              link_type
            }
            footer_column_navigation_featured
          }
          footer_column_1_heading {
            text
            type
          }
          footer_column_2_content {
            footer_column_navigation_label {
              text
              type
            }
            footer_column_navigation_link {
              url
              link_type
            }
            footer_column_navigation_featured
          }
          footer_column_2_heading {
            text
            type
          }
          footer_column_3_content {
            footer_column_navigation_label {
              text
              type
            }
            footer_column_navigation_link {
              url
              link_type
            }
            footer_column_navigation_featured
          }
          footer_column_3_heading {
            text
            type
          }
          footer_column_4_content {
            footer_column_navigation_label {
              text
              type
            }
            footer_column_navigation_link {
              url
              link_type
            }
            footer_column_navigation_featured
          }
          footer_column_4_heading {
            text
            type
          }
          footer_form_heading {
            text
            type
          }
          footer_social_icons {
            footer_social_icon_image {
              url
              alt
              dimensions {
                height
                width
              }
            }
            footer_social_icon_link {
              url
              link_type
            }
          }
        }
      }
    }
  `);

  return (
    <Flex as="footer" bg="#1F4D67" justifyContent="center">
      <MaxWidthBackgroundWrapper
        position="relative"
        pt={[8, 8, 10]}
        pb={7}
        px={maxWidthPadding}
        justifyContent="center"
      >
        <MaxWidthContentWrapper flexDirection="column" px={[0, 0, 5]}>
          {/* <Flex flexDirection={['column', 'column', 'row']}>
            <Flex flexDirection="column" width="30%" minWidth="250px">
              <P color="white" mb={4} fontSize={0}>
                {data.footer?.content?.footer_form_heading?.[0]?.text}
              </P>
              <Flex mb={[8, 8, 0]} mr={[5, 5, 5, 10]} flexDirection={'column'}>
                <Input placeholder="Full name" mr={3} mb={4} bg="bismark" />
                <Input placeholder="Email address" mr={3} mb={4} bg="bismark" />

                <Button
                  label="Submit"
                  variant="dark"
                  width="150px"
                  onClick={() => null}
                />
              </Flex>
            </Flex>
            <Flex flexWrap="wrap" flex="auto">
              <FooterLinks
                heading={
                  data.footer?.content?.footer_column_2_heading?.[0]?.text
                }
                links={data.footer?.content?.footer_column_2_content}
              />
              <FooterLinks
                heading={
                  data.footer?.content?.footer_column_3_heading?.[0]?.text
                }
                links={data.footer?.content?.footer_column_3_content}
              />
              <FooterLinks
                heading={
                  data.footer?.content?.footer_column_3_heading?.[0]?.text
                }
                links={data.footer?.content?.footer_column_3_content}
              />
              <FooterLinks
                heading={
                  data.footer?.content?.footer_column_4_heading?.[0]?.text
                }
                links={data.footer?.content?.footer_column_4_content}
              />
            </Flex>
          </Flex> */}
          <Flex flexDirection="column" alignSelf="center">
            <SocialIcons icons={data.footer?.content?.footer_social_icons} />
            <Flex flexDirection="row" alignSelf="center">
              <Link
                href="/privacy-policy"
                color="silver"
                fontSize={0}
                textAlign="center"
              >
                Privacy Policy &nbsp;
              </Link>
              <P color="silver" fontSize={0} textAlign="center">
                © 2021 Tahora Ltd
              </P>
            </Flex>
          </Flex>
        </MaxWidthContentWrapper>
        <Flex
          position="absolute"
          display={desktopOnlyDisplay}
          width="15%"
          right={0}
          bottom={0}
          zIndex={0}
        >
          <DesktopShape />
        </Flex>
      </MaxWidthBackgroundWrapper>
    </Flex>
  );
};

export default Footer;
